interface Icons {
  [key: string]: string;
}

const icons: Icons = {};
const context = require.context('@swf/core/assets/localized', false, /\.embed.svg$/, 'eager');
context.keys().forEach((key) =>
  context(key).then((icon: string) => {
    icons[key.slice(2).replace('.embed.svg', '')] = icon;
  })
);

export default icons;
